"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_light_right_style_1 = __importDefault(require("./uicon.arrow.light.right.style"));
class UiconArrowLightRight extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M21.4138 15.9157L9.31373 28.0158C8.89542 28.4341 8.89542 29.1124 9.31373 29.5308C9.73217 29.949 10.4104 29.949 10.8288 29.5308L23.6863 16.6732C24.1046 16.2549 24.1046 15.5766 23.6863 15.1582L10.8288 2.30065C10.4031 1.88956 9.72482 1.90136 9.31373 2.32702C8.91275 2.74225 8.91275 3.40051 9.31373 3.81568L21.4138 15.9157Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconArrowLightRight.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconArrowLightRight.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_light_right_style_1.default)(UiconArrowLightRight);
//# sourceMappingURL=uicon.arrow.light.right.js.map